export default function(num) {
  const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  return months[Number(num) - 1];
};



// WEBPACK FOOTER //
// ./src/modules/getMonthLabelFromNumber.js